import { Box } from '@mui/material';

import SectionLoader from 'components/shared/SectionLoader';
import { MouseEvent } from 'react';
import { useAppSelector } from 'store/hooks';
import { BusinessType } from 'store/slices/businessesSlice';
import Card from '../Card';
import NoResults from '../NoResults';
import { muiStyles } from './muiStyles';

const Grid = ({
  handleOpenSettings,
  isMybusinessesTab,
}: {
  handleOpenSettings: (event: MouseEvent<SVGSVGElement>, data: BusinessType) => void;
  isMybusinessesTab: boolean;
}) => {
  const { businesses, loading } = useAppSelector((state) => state.businesses);

  if (loading === 'in-progress') return <SectionLoader />;
  if (!businesses.length) return <NoResults isMybusinessesTab={isMybusinessesTab} />;

  return (
    <Box sx={muiStyles.grid}>
      {businesses.map((item) => (
        <Card key={item.businessId} data={item} onSettingsClick={handleOpenSettings} />
      ))}
    </Box>
  );
};

export default Grid;
